import React, {Component, ReactElement} from 'react'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import NatCondominiumRepo from '../condominium/repository/NatCondominiumRepo'
import NatDisasterRepo from './repository/NatDisasterRepo'
import {Nullable} from '../../../app/TypeHelpers'
import {Box} from '@mui/material'
import {NatAdminDisasterModeSettingForm} from './admin/NatAdminDisasterModeSettingForm'
import {CondominiumInfo} from '../condominium/repository/NatGetCondominiumList'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {Messages} from '../../../Messages'
import {Location} from 'react-router-dom'

interface Props {
    condominiumGroupRepo: NatCondominiumGroupRepo
    condominiumRepo: NatCondominiumRepo
    disasterRepo: NatDisasterRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

class NatAdminDisasterModeReleasePage extends Component<Props & AdminPagePropsSet> {
    constructor(props: Props & AdminPagePropsSet) {
        super(props)
    }

    handleDisasterReleaseButtonClink = async (condominiumList: CondominiumInfo[]): Promise<void> => {
        const {disasterRepo, eventEmitter} = this.props
        const condominiumCdList = condominiumList.map(condominium => condominium.condominiumCd)

        await eventEmitter.showLoading()
        try {
            const response = await this.props.asyncCallFunction(
                disasterRepo.releaseDisasterMode.bind(disasterRepo, condominiumCdList),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(eventEmitter)
                }
            )

            if (response && response.requestError === null) {
                this.props.navigate('/admin/disasters/mode/statuses',
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IDISA0001.toString('を解除')
                            }
                        }
                    }
                )
            }
        } finally {
            eventEmitter.closeLoading()
        }
    }

    render(): Nullable<ReactElement> {
        return <>
            <Box height={'9px'}/>
            <div>災害時モードを解除すると、居住者画面で下記が使用できなくなります。</div>
            <div>・災害時にのみ公開する防災情報の確認</div>
            <div>・災害時情報共有の利用</div>
            <Box height={'16px'}/>
            <NatAdminDisasterModeSettingForm
                mode={'release'}
                disasterModeEnableButtonText={'災害時モードを解除する'}
                onDisasterModeSetting={this.handleDisasterReleaseButtonClink}
                condominiumGroupRepo={this.props.condominiumGroupRepo}
                condominiumRepo={this.props.condominiumRepo}
                eventEmitter={this.props.eventEmitter}
                asyncCallFunction={this.props.asyncCallFunction}
                navigate={this.props.navigate}
                location={this.props.location}
            />
        </>
    }
}

export default createAdminPage(NatAdminDisasterModeReleasePage)
